import { useCallback, useState } from 'react';

type AboutDialogState = [boolean, () => void, () => void];

export const useAboutDialogState = ({
  onMenuClose
}: {
  onMenuClose: () => void;
}): AboutDialogState => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const onMenuItemClick = useCallback(() => {
    onMenuClose();
    setDialogOpen(true);
  }, [onMenuClose, setDialogOpen]);

  const onClose = useCallback(() => {
    setDialogOpen(false);
  }, [setDialogOpen]);

  return [dialogOpen, onMenuItemClick, onClose];
};
